var map = {
	"./accounts.js": "260b2",
	"./analysis.js": "1348",
	"./auth.js": "11c0",
	"./authfack.js": "8dd5",
	"./consumables.js": "1ccc",
	"./customers.js": "6d1f",
	"./expenses.js": "f18a",
	"./general.js": "ee52",
	"./instocktransfer.js": "a29a",
	"./invoices.js": "02d3",
	"./layout.js": "c21a",
	"./messages.js": "2f9c",
	"./notification.js": "2208",
	"./products.js": "22ca",
	"./purchase.js": "5f2e",
	"./saledetails.js": "ffae",
	"./sales.js": "b600",
	"./setting.js": "79a0",
	"./staff.js": "f917",
	"./stock.js": "0719",
	"./stocktransfer.js": "f3f4",
	"./store.js": "5c9c",
	"./todo.js": "3747",
	"./users.js": "b20d",
	"./visualisation.js": "06d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";